'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.ListWithLoader = exports.useListWithLoader = void 0;

var _extends2 = require('babel-runtime/helpers/extends'),
    _extends3 = _interopRequireDefault(_extends2),
    _slicedToArray2 = require('babel-runtime/helpers/slicedToArray'),
    _slicedToArray3 = _interopRequireDefault(_slicedToArray2),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _Text = require('office-ui-fabric-react/lib/Text'),
    _ShowHide = require('../ShowHide'),
    _ShowHide2 = _interopRequireDefault(_ShowHide),
    _Spinner = require('office-ui-fabric-react/lib/Spinner'),
    _ListItemRenderer = require('../ListItemRenderer'),
    _ListItemRenderer2 = _interopRequireDefault(_ListItemRenderer),
    _officeUiFabricReact = require('office-ui-fabric-react');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var useListWithLoader = exports.useListWithLoader = function () {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = _react2.default.useState(a),
      c = (0, _slicedToArray3.default)(b, 2),
      d = c[0],
      e = c[1];

  return (0, _extends3.default)({}, d, {
    setState: e
  });
},
    ListWithLoader = exports.ListWithLoader = function (a) {
  var b = a.showLoader,
      c = a.items,
      d = a.itemKey,
      e = a.showItems,
      f = a.CustomComponent,
      g = a.noItemsMsg,
      h = a.showNoItemsMsg;
  return _react2.default.createElement(_officeUiFabricReact.Stack, null, _react2.default.createElement(_ShowHide2.default, {
    show: b
  }, _react2.default.createElement(_Spinner.Spinner, {
    size: _Spinner.SpinnerSize.large
  })), _react2.default.createElement(_ShowHide2.default, {
    show: e
  }, _react2.default.createElement(_ListItemRenderer2.default, {
    items: c,
    itemKey: d,
    CustomComponent: f
  })), _react2.default.createElement(_ShowHide2.default, {
    show: h
  }, _react2.default.createElement(_officeUiFabricReact.Stack.Item, null, _react2.default.createElement(_Text.Text, null, g))));
};
/**
A complete **list rendering solution**.  It
has loading-state, with-items  state and
without-items  state.
*/


ListWithLoader.propTypes = {
  // loading-state props
  showLoader: _propTypes2.default.bool.isRequired,
  // with-item props
  items: _propTypes2.default.array.isRequired,
  itemKey: _propTypes2.default.string.isRequired,
  showItems: _propTypes2.default.bool.isRequired,
  CustomComponent: _propTypes2.default.node.isRequired,
  // without-item props
  noItemsMsg: _propTypes2.default.string.isRequired,
  showNoItemsMsg: _propTypes2.default.bool.isRequired
}, exports.default = ListWithLoader;